import { render, staticRenderFns } from "./historyArticle.vue?vue&type=template&id=e336b938&scoped=true&"
import script from "./historyArticle.vue?vue&type=script&lang=js&"
export * from "./historyArticle.vue?vue&type=script&lang=js&"
import style0 from "./historyArticle.vue?vue&type=style&index=0&id=e336b938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e336b938",
  null
  
)

export default component.exports